import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { interval, Subscription } from 'rxjs';
import isEmpty from 'src/app/lib/isEmpty';
import { BotService } from 'src/app/services/bot.service';

@Component({
  selector: 'app-dcabotpreview',
  templateUrl: './dcabotpreview.component.html',
  styleUrls: ['./dcabotpreview.component.css']
})
export class DcabotpreviewComponent {
  @Input() botDetails: any
  @Input() orderPlaceDet: any
  showPrevious = false
  startBot = false
  closeBot = false
  showTimer: boolean = false;

  createdAtTime: Date | null = null;
  remainingTime: string = '';
  timerSubscription!: Subscription;
  canStartBot: boolean = true;
  constructor(
    private service: BotService,
    private toastr: ToastrService,
  ) {
  }
  ngOnInit() {
    this.blockBots()
    console.log(this.botDetails, '-----11')
  }
  handlePrevious() {
    this.showPrevious = true
  }
  blockBots() {
    this.service.blockBot().subscribe({
      next: (res: any) => {
        const result = res.result;

        // No data: allow bot to start
        if (!result || !result.createdAt) {
          this.canStartBot = true;
          return;
        }

        const createdAt = new Date(result.createdAt).getTime();
        const currentTime = Date.now();
        const diffInSeconds = Math.floor((currentTime - createdAt) / 1000);

        // const BLOCK_TIME_SECONDS = 7 * 24 * 60 * 60; // 604800;
        const BLOCK_TIME_SECONDS = 120; ;

        if (diffInSeconds < BLOCK_TIME_SECONDS) {
          const remainingSeconds = BLOCK_TIME_SECONDS - diffInSeconds;
          this.canStartBot = false;
          this.startCountdown(remainingSeconds);
          this.showTimer = true;
        } else {
          this.canStartBot = true;
          this.remainingTime = 'Expired';
          this.showTimer = false;
        }

        // this.toastr.success(res.message || 'Bot Blocked Successfully');
      },
      error: (err: any) => {
        this.canStartBot = true; // Allow start on API error
        console.error('Error in blockBot API:', err);
        this.toastr.error('Something went wrong while blocking the bot.');
      }
    });
  }

  startCountdown(secondsLeft: number) {
    this.updateRemainingTime(secondsLeft);

    this.timerSubscription = interval(1000).subscribe(() => {
      secondsLeft--;

      if (secondsLeft <= 0) {
        this.remainingTime = '0:00';
        this.canStartBot = true;
        this.showTimer = false;
        this.timerSubscription.unsubscribe();
      } else {
        this.updateRemainingTime(secondsLeft);
      }
    });
  }

  updateRemainingTime(seconds: number) {

    
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    this.remainingTime = `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  }
  // updateRemainingTime(seconds: number) {
  //   const days = Math.floor(seconds / (24 * 3600));
  //   const hours = Math.floor((seconds % (24 * 3600)) / 3600);
  //   const mins = Math.floor((seconds % 3600) / 60);
  //   const secs = seconds % 60;
  
  //   this.remainingTime = `${days}d ${hours}h ${mins}m ${secs < 10 ? '0' : ''}${secs}s`;
  // }
  

  submitForm(reqData: any) {
    if (!this.canStartBot) return;

    this.startBot = true;
    this.service.dcaOrderPlace(reqData).subscribe({
      next: (v: any) => {
        this.startBot = false;
        this.closeBot = true;
        this.toastr.success(v.message);
      },
      error: (err: any) => {
        this.startBot = false;
        if ([400, 404].includes(err.status)) {
          const validationErrors = err.error.errors;
          if (!isEmpty(validationErrors)) {
            if (err?.error?.errors?.order) {
              this.toastr.error(err.error.errors.order);
            }
          }
        } else if (err.status === 500) {
          this.toastr.error(err.error.message);
        }
      },
    });
  }
}


